// Module
var code = "<div class=\"uip-item-menu__item uip-item-menu__item--logout\"> <div class=\"uip-item-menu__item-label\"> <span class=\"material-icons-outlined md-18 mr-2\"> logout </span> [[Logout]] </div> </div>";
// Exports
module.exports = code;